import {getRefreshToken, getTokenFromSession, refreshIdToken} from "../services/authenticate";
import axiosInstance from "../axiosInstance";
import {api} from "../api";

export const getOrder = async ({orderId}) => {
    const token = getTokenFromSession();
    try {
        return await axiosInstance.get(`${api.order}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `${token}`,
            },
            params: {orderId},
        })
    } catch (error) {
        if (error.response?.status === 401 || error.response?.status === 403) {
            const refreshToken = getRefreshToken();
            sessionStorage.setItem("intendedPage", `/order/${orderId}`);

            if (!refreshToken) {
                alert("Session expired. Please log in again.");
                window.location.href = "/";
                return;
            }
            try {
                await refreshIdToken(refreshToken);
                await getOrder({orderId});
            } catch (refreshErr) {
                console.error("Token refresh failed:", refreshErr);
                window.location.href = "/";
            }
        }
    }
}

export const updateStatusByStockIdAndOrderType = async ({body, orderType, orderId}) => {
    const token = getTokenFromSession();
    try {
        return await axiosInstance.put(`${api.order}`, body, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `${token}`,
            },
            params: {orderType},
        })
    } catch (error) {
        console.error("Error fetching book details:", error);
        if (error.response?.status === 401 || error.response?.status === 403) {
            const refreshToken = getRefreshToken();
            sessionStorage.setItem("intendedPage", `/order/${orderId}`);

            if (!refreshToken) {
                alert("Session expired. Please log in again.");
                window.location.href = "/";
                return;
            }
            try {
                await refreshIdToken(refreshToken);
                await updateStatusByStockIdAndOrderType({body, orderType, orderId});
            } catch (refreshErr) {
                console.error("Token refresh failed:", refreshErr);
                window.location.href = "/";
            }
        }
    }
}


export const updateStatusByOrderIdAndStatus = async ({body, orderId}) => {
    const token = getTokenFromSession();
    try {
        return await axiosInstance.put(`${api.order}`, body, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `${token}`,
            },
        })
    } catch (error) {
        console.error("Error fetching book details:", error);
        if (error.response?.status === 401 || error.response?.status === 403) {
            const refreshToken = getRefreshToken();
            sessionStorage.setItem("intendedPage", `/order/${orderId}`);

            if (!refreshToken) {
                alert("Session expired. Please log in again.");
                window.location.href = "/";
                return;
            }
            try {
                await refreshIdToken(refreshToken);
                await updateStatusByOrderIdAndStatus({body, orderId});
            } catch (refreshErr) {
                console.error("Token refresh failed:", refreshErr);
                window.location.href = "/";
            }
        }
    }
}

export const getStockDetails = async ({stockId}) => {
    const token = getTokenFromSession();
    try {
        return await axiosInstance.get(`${api.order}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `${token}`,
            },
            params: {stockId}
        })
    } catch (error) {
        console.error("Error fetching stock details:", error);
        if (error.response?.status === 401 || error.response?.status === 403) {
            const refreshToken = getRefreshToken();
            sessionStorage.setItem("intendedPage", `itemAdd`);

            if (!refreshToken) {
                alert("Session expired. Please log in again.");
                window.location.href = "/";
                return;
            }
            try {
                await refreshIdToken(refreshToken);
                await getStockDetails({stockId});
            } catch (refreshErr) {
                console.error("Token refresh failed:", refreshErr);
                window.location.href = "/";
            }
        }
    }
}
